export default __webpack_public_path__ + "static/media/learose2-1440w.54529ee3.png";